import { PaginatedColumn } from '../types/app';
import { MassiveCommandRequest, MassiveCommandRequestTouched } from '../types/massiveCommands';

export const MASSIVE_TABLE_COLUMNS_NAME: PaginatedColumn[] = [
  {
    label: 'Dispositivo',
    key: 'deviceModel',
  },
  {
    label: 'Comando',
    key: 'command',
  },
  {
    label: 'Creado',
    key: 'created',
  },
  {
    label: 'Estado',
    key: 'status',
  },
  {
    label: 'Acciones',
    key: 'actions',
    minWidth: 120,
    maxWidth: 120,
    centered: true,
  },
];

export const EMPTY_MASSIVE_COMMAND: MassiveCommandRequest = {
  deviceModelId: '',
  command: '',
  idents: [],
};

export const MASSIVE_TOUCHED_DEFAULTS: MassiveCommandRequestTouched = {
  deviceModelTouched: false,
  commandTouched: false,
  fileTouched: false,
};

export const MASSIVE_COMMANDS_FILE_EXAMPLE = 'public/massiveCommandExamples/devices.csv';

export const MASSIVE_COMMANDS_PENDING_STATUS = 'pending';
export const MASSIVE_COMMANDS_PROCESSED_STATUS = 'processed';

export const MASSIVE_COMMANDS_STATUSES = {
  [MASSIVE_COMMANDS_PENDING_STATUS]: 'PENDIENTE',
  [MASSIVE_COMMANDS_PROCESSED_STATUS]: 'PROCESADO',
};

export const MASSIVE_COMMANDS_RESPONSE_TABLE_COLUMNS_NAME: PaginatedColumn[] = [
  {
    label: 'Dispositivo',
    key: 'asset',
  },
  {
    label: 'Ident',
    key: 'ident',
  },
  {
    label: 'Estado',
    key: 'status',
    minWidth: 120,
    maxWidth: 120,
    centered: true,
  },
  {
    label: 'Motivo',
    key: 'reason',
  },
];
